<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-s-tools"></i> GM 相关</el-breadcrumb-item>
                <el-breadcrumb-item>GM 工具</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container" style="min-width: 900px">
            <div class="plugins-tips">

                <span class="tips-title">项目名称：</span>
                <el-select size='mini' @change='logProject' filterable v-model="query.projectName" placeholder="请选择">
                    <el-option
                        v-for="item in projectInfoList"
                        :key="item.id"
                        :label="item.cnName"
                        :value="item.name">
                    </el-option>
                </el-select>
            </div>
            <div v-if="query.projectName === 'MARSPARK'">
                <Marspark></Marspark>
            </div>
            <div v-if='query.projectName === "The Lilliput Workshop"'>
                <Lilliput/>
            </div>
        </div>
    </div>
</template>

<script>
import Marspark from './mars/Marspark.vue';
import { queryProjectInfoList } from '../../api/ProjectInfo';
import Lilliput from '@view/gamemanager/lilliput/Lilliput.vue';

export default {
    name: 'Gameconsole',
    components: {
        Lilliput,
        Marspark
    },
    data: function () {
        return {
            query: {
                projectName: undefined  //项目名
            },
            projectInfoList: []
        };
    },
    created() {
        this.getList()
    },
    activated() {
        this.getList()
    },
    methods: {
        getList() {
            queryProjectInfoList({pageSize: 100000}).then(result => {
                if (result.code === 200) {
                    this.projectInfoList = result.data.result
                    console.log(this.projectInfoList);
                }
            })
        },
        //项目信息 下拉框
        current(event) {
            this.query.projectName = event.name
        },
        logProject(projectName) {
            console.log(`当前选择的项目名为${projectName}`);
        }
    }
}
</script>